import { Component, Input } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { ScIconPipe } from '@core/jss-utils';

import { MinimalSubVariant } from './list-variant-minimal.model';
import { ListVariantBaseComponent } from '../list-variant.base.component';

@Component({
  selector: 'wl-list-variant-minimal',
  templateUrl: './list-variant-minimal.component.html',
  styleUrls: [
    './list-variant-minimal.component.ed.scss',
    './list-variant-minimal.component.essent.scss',
  ],
  standalone: true,
  imports: [JssModule, FaIconComponent, RichTextWrapperComponent, ScIconPipe],
})
export class ListVariantMinimalComponent extends ListVariantBaseComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subVariant: MinimalSubVariant = 'brand';
}
